export const COLOR_KEYS = [
  'primaryLight',
  'primaryLighter',
  'primaryLight1',
  'primaryLight2',
  'primaryDark',
  'primaryBorder',
  'leftMenuBg',
  'shadow',
  'shadow1',
  'darkGray',
  'darkGray1',
  'lightGray',
  'remove',
  'lightRemove',
  'bgGray',
  'borderGray',
  'activeMenuItem',
  'placeholderGray',
  'copyRight',
  'tableGray',
  'black',
  'white',
  'gray',
  'gray1',
  'gray2',
  'gray3',
  'gray4',
  'gray5',
  'gray6',
  'gray7',
  'gray8',
  'gray9',
  'gray10',
  'gray11',
  'gray12',
  'darkBlue',
  'blue',
] as const;
